module.exports = __webpack_public_path__ + "media/images/cupos-w-9a9e1842ef923a70a058e96c7a542fc7.png";